import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon, HeartIcon, CheckIcon, XIcon } from 'lucide-react';
export function PricingSection() {
  const [selectedOption, setSelectedOption] = useState<'pro' | 'base'>('pro');
  return <section className="w-full py-20 md:py-24 px-4 bg-[#5A9E80] text-white" id="pricing" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <div className="text-center mb-12" data-id="element-89">
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4 text-white" data-id="element-90">
            ELEGÍ TU OPCIÓN
          </h2>
          <p className="text-xl text-white/80" data-id="element-91">
            Seleccioná el pack que mejor se adapte a tu familia.
          </p>
        </div>

        {/* Pricing Selector Card */}
        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-[#7CB69D]/30 mb-12" data-id="element-92">
          {/* Option 1: PRO */}
          <div role="button" tabIndex={0} aria-pressed={selectedOption === 'pro'} onClick={() => setSelectedOption('pro')} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelectedOption('pro');
          }
        }} className={`relative rounded-2xl p-6 mb-6 cursor-pointer transition-all duration-300 border-2 ${selectedOption === 'pro' ? 'border-primary-green bg-[#EDF7F0]' : 'border-transparent bg-transparent hover:bg-[#EDF7F0]/50'}`} data-id="element-93">
            <div className="flex flex-col md:flex-row md:items-start justify-between" data-id="element-94">
              <div className="flex items-start" data-id="element-95">
                <div className={`mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center mr-4 flex-shrink-0 ${selectedOption === 'pro' ? 'border-primary-green' : 'border-gray-400'}`} data-id="element-96">
                  {selectedOption === 'pro' && <div className="w-3 h-3 bg-primary-green rounded-full" data-id="element-97"></div>}
                </div>

                <div data-id="element-98">
                  <div className="flex items-center mb-2" data-id="element-99">
                    <TrophyIcon className="w-5 h-5 text-amber-400 mr-2" data-id="element-100" />
                    <h3 className="text-2xl font-bold text-text-heading" data-id="element-101">
                      COMBO COMPLETO
                    </h3>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-102">
                    <span className="bg-primary-green text-white text-xs font-bold px-3 py-1 rounded-md flex items-center" data-id="element-103">
                      <StarIcon className="w-3 h-3 mr-1 fill-white" data-id="element-104" /> MÁS
                      ELEGIDO
                    </span>
                    <span className="border border-[#3D7A5E] text-[#3D7A5E] text-xs font-bold px-3 py-1 rounded-full" data-id="element-105">
                      AHORRAS $10.000
                    </span>
                  </div>

                  <div className="text-text-body space-y-1" data-id="element-106">
                    <p className="text-lg" data-id="element-107">4 Tomos + 2 Bonos</p>
                    <p className="font-bold text-text-heading mt-2" data-id="element-108">
                      + Kit de Implementación Rápida
                    </p>
                    <p className="text-sm pl-4 border-l-2 border-gray-300 ml-1" data-id="element-109">
                      - 12 Tarjetas SOS de Crisis
                    </p>
                    <p className="text-sm pl-4 border-l-2 border-gray-300 ml-1" data-id="element-110">
                      - Tablero de Progreso Visual
                    </p>
                    <p className="text-sm pl-4 border-l-2 border-gray-300 ml-1" data-id="element-111">
                      - Guía Rápida 7 Días
                    </p>
                    <p className="text-sm pl-4 border-l-2 border-gray-300 ml-1" data-id="element-112">
                      - Kit Comunicación Familiar
                    </p>
                    <p className="text-sm pl-4 border-l-2 border-gray-300 ml-1" data-id="element-113">
                      - Diario de Regulación Parental
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 md:mt-0 text-left md:text-right pl-10 md:pl-0" data-id="element-114">
                <p className="text-gray-500 line-through text-lg" data-id="element-115">$44.990</p>
                <p className="text-4xl md:text-5xl font-bold text-[#3D7A5E]" data-id="element-116">
                  $29.990
                </p>
              </div>
            </div>
          </div>

          {/* Option 2: BASE */}
          <div role="button" tabIndex={0} aria-pressed={selectedOption === 'base'} onClick={() => setSelectedOption('base')} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelectedOption('base');
          }
        }} className={`relative rounded-2xl p-6 cursor-pointer transition-all duration-300 border-2 ${selectedOption === 'base' ? 'border-primary-green bg-[#EDF7F0]' : 'border-transparent bg-transparent hover:bg-[#EDF7F0]/50'}`} data-id="element-117">
            <div className="flex flex-col md:flex-row md:items-center justify-between" data-id="element-118">
              <div className="flex items-center" data-id="element-119">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center mr-4 flex-shrink-0 ${selectedOption === 'base' ? 'border-primary-green' : 'border-gray-400'}`} data-id="element-120">
                  {selectedOption === 'base' && <div className="w-3 h-3 bg-primary-green rounded-full" data-id="element-121"></div>}
                </div>

                <div className="flex items-center" data-id="element-122">
                  <HeartIcon className="w-5 h-5 text-primary-green mr-2 fill-primary-green" data-id="element-123" />
                  <h3 className="text-xl font-bold text-text-heading mr-4" data-id="element-124">
                    MÉTODO BASE
                  </h3>
                  <span className="text-text-body" data-id="element-125">4 Tomos + 2 Bonos</span>
                </div>
              </div>

              <div className="mt-4 md:mt-0 flex items-center md:justify-end pl-10 md:pl-0" data-id="element-126">
                <p className="text-gray-500 line-through mr-4" data-id="element-127">$34.000</p>
                <p className="text-3xl font-bold text-text-heading" data-id="element-128">$19.990</p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-8" data-id="element-129">
            <a href={selectedOption === 'pro' ? 'https://fegion.shop/cart/46217733341323:1' : 'https://fegion.shop/cart/46217733111947:1'} className="block w-full bg-[#3D8C5A] hover:bg-[#327A4D] text-white text-center py-5 rounded-xl text-xl font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center justify-center" data-id="element-130">
              <HeartIcon className="w-6 h-6 mr-3 fill-white" data-id="element-131" />
              EMPEZAR HOY — {selectedOption === 'pro' ? '$29.990' : '$19.990'}
            </a>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl overflow-hidden text-text-body shadow-xl" data-id="element-132">
          <div className="overflow-x-auto" data-id="element-133">
            <table className="w-full text-left border-collapse" data-id="element-134">
              <thead data-id="element-135">
                <tr className="bg-gray-50 border-b border-gray-200" data-id="element-136">
                  <th className="p-4 md:p-6 font-bold text-text-heading w-1/2" scope="col" data-id="element-137">
                    <span className="sr-only" data-id="element-138">Característica</span>
                  </th>
                  <th className="p-4 md:p-6 font-bold text-center text-text-heading border-l border-gray-200" scope="col" data-id="element-139">
                    MÉTODO BASE
                  </th>
                  <th className="p-4 md:p-6 font-bold text-center text-white bg-[#5A9E80] border-l border-gray-200" scope="col" data-id="element-140">
                    MÉTODO + KIT
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-141">
                <tr data-id="element-142">
                  <td className="p-4 md:p-6 font-medium" data-id="element-143">4 Tomos del Método</td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-144">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-145" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-146">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-147" />
                  </td>
                </tr>
                <tr data-id="element-148">
                  <td className="p-4 md:p-6 font-medium" data-id="element-149">
                    Bono #1 Alimentos Puente
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-150">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-151" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-152">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-153" />
                  </td>
                </tr>
                <tr data-id="element-154">
                  <td className="p-4 md:p-6 font-medium" data-id="element-155">
                    Bono #2 Laboratorio Texturas
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-156">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-157" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-158">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-159" />
                  </td>
                </tr>
                <tr data-id="element-160">
                  <td className="p-4 md:p-6 font-medium" data-id="element-161">
                    12 Tarjetas SOS de Crisis
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-162">
                    <XIcon className="w-6 h-6 text-gray-300 mx-auto" data-id="element-163" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-164">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-165" />
                  </td>
                </tr>
                <tr data-id="element-166">
                  <td className="p-4 md:p-6 font-medium" data-id="element-167">
                    Tablero de Progreso Visual
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-168">
                    <XIcon className="w-6 h-6 text-gray-300 mx-auto" data-id="element-169" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-170">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-171" />
                  </td>
                </tr>
                <tr data-id="element-172">
                  <td className="p-4 md:p-6 font-medium" data-id="element-173">Guía Rápida 7 Días</td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-174">
                    <XIcon className="w-6 h-6 text-gray-300 mx-auto" data-id="element-175" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-176">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-177" />
                  </td>
                </tr>
                <tr data-id="element-178">
                  <td className="p-4 md:p-6 font-medium" data-id="element-179">
                    Kit Comunicación Familiar
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-180">
                    <XIcon className="w-6 h-6 text-gray-300 mx-auto" data-id="element-181" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-182">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-183" />
                  </td>
                </tr>
                <tr data-id="element-184">
                  <td className="p-4 md:p-6 font-medium" data-id="element-185">
                    Diario Regulación Parental
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200" data-id="element-186">
                    <XIcon className="w-6 h-6 text-gray-300 mx-auto" data-id="element-187" />
                  </td>
                  <td className="p-4 md:p-6 text-center border-l border-gray-200 bg-gray-50" data-id="element-188">
                    <CheckIcon className="w-6 h-6 text-primary-green mx-auto" data-id="element-189" />
                  </td>
                </tr>
                <tr className="bg-gray-50" data-id="element-190">
                  <td className="p-4 md:p-6 font-bold text-text-heading" data-id="element-191">
                    PRECIO
                  </td>
                  <td className="p-4 md:p-6 text-center font-bold text-xl text-text-heading border-l border-gray-200" data-id="element-192">
                    $19.990
                  </td>
                  <td className="p-4 md:p-6 text-center font-bold text-2xl text-[#3D7A5E] border-l border-gray-200 bg-gray-100" data-id="element-193">
                    $29.990
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 bg-[#EDF7F0] rounded-xl p-6 flex items-start border border-primary-green/20" data-id="element-194">
          <div className="text-2xl mr-4" data-id="element-195">💡</div>
          <p className="text-text-body leading-relaxed" data-id="element-196">
            El Kit de Implementación por separado vale $25.000 ARS.Agregándolo
            ahora lo llevás a menos del 50%
          </p>
        </div>
      </div>
    </section>;
}
// Small helper component for the star icon since it wasn't imported from lucide-react at the top
function StarIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-197">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-198" />
    </svg>;
}